/***
 * @ngdoc directive
 * @name BB:bbAriaHideOnLoad
 * @restrict A
 *
 * @description
 *
 * This directive is intended to be used in order to disable screen reader access
 * to the entire widget while in the loading state. It should be applied to the container
 * of the bb-widget.
 *
 * While loading is happening aria-hidden="true" is applied to the element and when loading
 * finishes aria-hidden="false" is applied.
 * This prevents the screen reader from reading out the page while the user cannot use it properly.
 *
 * An assertive aria live announcement is made to the user to indicate that loading has started
 * and finished accordingly. To change what the screen reader says to the user change the values of
 * CORE.ACCESSIBILITY.LOADING and CORE.ACCESSIBILITY.LOADING_FINISHED in the translation files.
 *
 * <example module="BB">
 *  <file name="index.html">
 *    <div bb-api-url='https://uk.bookingbug.com'>
 *      <div bb-aria-hide-on-load>
 *        <div bb-widget>
 *        </div>
 *      </div>
 *    </div>
 *  </file>
 * </example>
 *
 *///
angular
    .module('BB')
    .directive('bbAriaHideOnLoad', AriaHideOnLoadDirective);

function AriaHideOnLoadDirective() {
    return {
        restrict: 'A',
        controller: function AriaHideOnLoadController($scope, $rootScope, $element, accessibility) {

            function hide() {
                $element.attr('aria-hidden', true);
                accessibility.announceAssertive('CORE.ACCESSIBILITY.LOADING');
            }

            function show() {
                $element.attr('aria-hidden', false);
                accessibility.announceAssertive('CORE.ACCESSIBILITY.LOADING_FINISHED');
            }

            const events = [
                $rootScope.$on('loading:started', hide),
                $rootScope.$on('loading:finished', show)
            ];

            $scope.$on('$destroy', () => events.forEach(e => e()));
        }
    };
}





// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/accessibility/aria_hide_on_load.directive.js